import React from "react";
import { Card, useTheme } from "@mui/material";

export default function GradientCard({
  children,
  variant,
  selected,
  background,
  sx,
  sxMobile,
  sxInnerMobile,
  onClick,
}) {
  const theme = useTheme();

  let outerSX = {
    background: !selected
      ? background
      : "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
    border: "1px solid #dddddd",
    ...sx,
    userSelect: "none",
  };
  let innerSX = {
    background: background,
    borderRadius: "6px",
    margin: "6px",
    padding: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    userSelect: "none",
    cursor: "pointer",
  };

  if (variant === "square") {
    outerSX = {
      ...outerSX,
      position: "relative",
      height: "0px",
      paddingBottom: "100%",
      [theme.breakpoints.down("laptop")]: {
        overflow: "visible",
        borderRadius: "6px",
        ...sxMobile,
      },
    };
    innerSX = {
      ...innerSX,
      position: "absolute",
      top: "0px",
      left: "0px",
      right: "0px",
      bottom: "0px",
      [theme.breakpoints.down("laptop")]: {
        margin: "0px",
        overflow: "visible",
        ...sxInnerMobile,
      },
    };
  }

  if (variant === "circle") {
    outerSX = {
      ...outerSX,
      position: "relative",
      height: "0px",
      paddingBottom: "100%",
      borderRadius: "50%",
    };
    innerSX = {
      ...innerSX,
      position: "absolute",
      top: "0px",
      left: "0px",
      right: "0px",
      bottom: "0px",
      borderRadius: "50%",
    };
  }

  return (
    <Card elevation={0} sx={outerSX} onClick={onClick}>
      <Card elevation={0} sx={innerSX}>
        {children}
      </Card>
    </Card>
  );
}
